import type { PlazaAvatar, PlazaFilters } from "@/features/plaza/types";
export async function readCatalogBatch(ids: string[], read: (id: string) => Promise<PlazaAvatar | undefined>) {
  const rows: Array<PlazaAvatar | undefined> = new Array(ids.length);
  let next = 0;
  await Promise.all(Array.from({ length: Math.min(4, ids.length) }, async () => {
    while (next < ids.length) { const i = next++; rows[i] = await read(ids[i]); }
  }));
  return rows.filter((row): row is PlazaAvatar => Boolean(row));
}

export function filterCatalog(rows: PlazaAvatar[], filters: PlazaFilters) {
  return rows.filter(row => {
    const text = `${row.title} ${row.category} ${row.tags.join(" ")} ${row.themes.join(" ")} ${row.bio} ${row.city}`.toLocaleLowerCase("zh-CN");
    return (filters.minPrice === undefined || row.price >= filters.minPrice)
      && (filters.maxPrice === undefined || row.price <= filters.maxPrice)
      && (filters.minFans === undefined || row.fansCount >= filters.minFans)
      && (!filters.category || row.category === filters.category)
      && (!filters.query || `${text} mira-${row.id.toLocaleLowerCase("zh-CN")}`.includes(filters.query.toLocaleLowerCase("zh-CN")))
      && (filters.popular ?? []).every(query => text.includes(query.toLocaleLowerCase("zh-CN")))
      && (filters.tags ?? []).every(tag => row.tags.includes(tag) || row.themes.includes(tag));
  }).sort((a, b) => {
    if (filters.sort === "fans") return b.fansCount - a.fansCount || b.publishedAt - a.publishedAt || a.id.localeCompare(b.id);
    if (filters.sort === "popular") return b.viewCount - a.viewCount || b.authorizationCount - a.authorizationCount || a.id.localeCompare(b.id);
    return (filters.sort === "recommend" ? Number(b.recommended) - Number(a.recommended) : 0) || b.publishedAt - a.publishedAt || a.id.localeCompare(b.id);
  });
}
